angular.module('mx.shell').service('mx.shell.LeftSidebarService', MxShellLeftSidebarService);

MxShellLeftSidebarService.$inject = ['$rootScope', 'mx.shell.EventService'];
export function MxShellLeftSidebarService($rootScope, eventService) {
	var service = this;
	var panels = [];
	var isVisible = true;
	var allPanelsDisabled = true;

	service.addPanel = addPanel;
	service.showPanelByName = showPanelByName;
	service.getCurrentPanelName = getCurrentPanelName;
	service.enablePanel = enablePanel;
	service.disablePanel = disablePanel;
	service.currentPanelIndex = 0;

	Object.defineProperty(service, 'panels', {
		get: function () {
			return panels;
		},
	});

	Object.defineProperty(service, 'isVisible', {
		get: function () {
			return isVisible && !allPanelsDisabled;
		},
		set: function (newValue) {
			isVisible = newValue;
		},
	});

	var debouncedShowPanel = $.debounce(300, function (panel, isTabChangedByUserManually = false) {
		$rootScope.$evalAsync(showPanel(panel, isTabChangedByUserManually));
	});

	service.showPanel = debouncedShowPanel;

	return service;

	function checkVisibility() {
		allPanelsDisabled = panels.every(function (panel) {
			return panel.disable;
		});
	}

	function addPanel(panel) {
		panels.push(panel);

		panels = panels.sort(function (panelA, panelB) {
			return panelA.order - panelB.order;
		});

		checkVisibility();
	}

	function showPanel(panel, isTabChangedByUserManually = false) {
		var index = panels.indexOf(panel);
		if (index >= 0 && (service.currentPanelIndex !== index || isTabChangedByUserManually)) {
			service.currentPanelIndex = index;
			eventService.dispatchEvent(mx.shell.EventCodes.LeftSidebarTabChanged, { panelName: panel.name, isTabChangedByUserManually });
		}
	}

	function getPanelByName(panelName) {
		return panels.filter(function (panel) {
			return panel.name === panelName;
		})[0];
	}

	function showPanelByName(panelName) {
		var panel = getPanelByName(panelName);
		debouncedShowPanel(panel);
	}

	function getCurrentPanelName() {
		return panels[service.currentPanelIndex]?.name;
	}

	function disablePanel(panelName) {
		var panel = getPanelByName(panelName);
		if (panel) {
			panel.disable = true;
			checkVisibility();
		}
	}

	function enablePanel(panelName) {
		var panel = getPanelByName(panelName);
		if (panel) {
			panel.disable = false;
			allPanelsDisabled = false;
		}
	}
}
